// import React from "react";
// import "./loginpage.css";

// const Loginpage = () => {
//   return (
//     <>
//       <div className="loginPage">
//         <h2>Crypto Investment Worldwide</h2>
//         <p>Welcome to our Platform</p>
//         <p>Please sign-in to your account and start the adventure</p>
//         <form action="" method="post" className="loginForm">
//           <label htmlFor="username">
//             Username{" "}
//             <input
//               className="loginBox"
//               type="text"
//               name="username"
//               id="username"
//             />
//           </label>{" "}
//           <label htmlFor="password">Password</label>{" "}
//           <input className="loginBox" type="password" name="" id="" />
//           <label htmlFor="rememberMe">
//             <input
//               className="checkboxLogin"
//               type="checkbox"
//               name=""
//               id="rememberMe"
//             />
//             Remember Me
//           </label>
//           <button>Login</button>
//         </form>
//         <div className="loginPageFoot">
//           New to our platform? <a href="/Signup">create an account</a>{" "}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Loginpage;

import React, { useState } from "react";
import bnbcry from "../../asset/bnbcry.png";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase/Firebase"; // Adjust the path based on your file structure
import { signInWithEmailAndPassword } from "firebase/auth";
import "./loginpage.css";

const Loginpage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Login successful!");
      navigate("/dashboardUser"); // Redirect to the dashboard or any other page
    } catch (err) {
      setError("Incorrect Login Details");
    }
  };

  return (
    <div className="loginPage">
      <img src={bnbcry} alt="" />
      <p>Welcome to our Platform</p>
      <p>Please sign-in to your account and start the adventure</p>
      <form onSubmit={handleLogin} className="loginForm">
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label htmlFor="password">Password:</label>{" "}
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
        {error && <p>{error}</p>}
      </form>
      <div className="loginPageFoot">
        New to our platform? <a href="/Signup">create an account</a>{" "}
      </div>
    </div>
  );
};

export default Loginpage;
